import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row-info badge ms-1" }
const _hoisted_2 = {
  key: 0,
  class: "row-info badge badge-info ms-1"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 3,
  class: "text-end"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 4,
  colspan: "4"
}
const _hoisted_13 = {
  key: 0,
  class: "edit-row"
}
const _hoisted_14 = ["colspan"]
const _hoisted_15 = {
  key: 1,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _component_PayerForm = _resolveComponent("PayerForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(`${_ctx.isDeleteRequested || _ctx.isEditRequested ? 'edit-row' : ''}`)
    }, [
      _createElementVNode("td", null, [
        (!_ctx.billAsTypeLabel)
          ? (_openBlock(), _createBlock(_component_EmptyTextHandler, {
              key: 0,
              text: _ctx.payorTypeLabel
            }, null, 8 /* PROPS */, ["text"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.billAsTypeLabel) + " ", 1 /* TEXT */),
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.payorTypeLabel), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.payer.AgencyPayorName
        }, null, 8 /* PROPS */, ["text"]),
        (_ctx.isUpcoming && !!_ctx.payer.AgencyPayorName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Upcoming "))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.payer.MemberId
        }, null, 8 /* PROPS */, ["text"])
      ]),
      (!_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.payer.GroupName
            }, null, 8 /* PROPS */, ["text"])
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.payer.GroupId
            }, null, 8 /* PROPS */, ["text"])
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.formatDate(_ctx.payer.EffectiveDate)
            }, null, 8 /* PROPS */, ["text"])
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
            (!_ctx.isEditRequested)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn table-btn btn-outline-info",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEditPayer()))
                }, _hoisted_8))
              : _createCommentVNode("v-if", true),
            (!_ctx.isEditRequested)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn table-btn btn-outline-danger",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmDeletePayer()))
                }, _hoisted_10))
              : _createCommentVNode("v-if", true),
            (_ctx.isEditRequested)
              ? (_openBlock(), _createElementBlock("i", _hoisted_11, "Edit In Progress"))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" DELETE "),
      (_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
            _createVNode(_component_TablePrompt, {
              "ok-text": "delete",
              name: "delete",
              "is-in-progress": _ctx.isDeleteInProgress,
              ok: _ctx.deletePayer,
              cancel: _ctx.cancelDeletePayer
            }, null, 8 /* PROPS */, ["is-in-progress", "ok", "cancel"])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createCommentVNode(" EDIT "),
    (_ctx.isEditRequested)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3 edit"
          }, [
            (_ctx.cachedData)
              ? (_openBlock(), _createBlock(_component_PayerForm, {
                  key: 0,
                  payer: _ctx.cachedData,
                  patientDetails: _ctx.patientDetails,
                  "is-loading": _ctx.isEditInProgress,
                  "is-add-form": false,
                  "medicare-ids": _ctx.medicareIds,
                  ref: "payerForm"
                }, null, 8 /* PROPS */, ["payer", "patientDetails", "is-loading", "medicare-ids"]))
              : _createCommentVNode("v-if", true),
            (!_ctx.isEditInProgress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary btn-md",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updatePayer()))
                  }, "Save Payer"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary btn-md ms-2",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeEditPayer()))
                  }, " Cancel ")
                ]))
              : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_14)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}